<template>
  <div class="highlight-comment-trigger-parts" @click="onClick">
    <atom-input-checkbox-parts
      class="highlight-comment-trigger-parts__checkbox"
      :value="triggerValue"
    />

    <label
      class="highlight-comment-trigger-parts__label"
      v-text="$tc('HomePage.snsHighlightCommentTriggerLabel')"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import AtomInputCheckboxParts from '@/components/atoms/input/AtomInputCheckbox.vue'

/**
 * HOME SNSコンテンツ ハイライトコメントトリガーパーツ
 */
export default defineComponent({
  name: 'HighlightsCommentTriggerParts',
  components: {
    AtomInputCheckboxParts,
  },
  props: {
    highlightTrigger: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  setup(props) {
    const triggerValue = computed((): boolean => props.highlightTrigger)
    return {
      triggerValue,
    }
  },
  methods: {
    /**
     * チェックボックスクリック通知
     */
    onClick() {
      this.$emit('click')
    },
  },
})
</script>

<style lang="scss" scoped>
.highlight-comment-trigger-parts {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  width: calc(100% - 40px);
  padding: 10px 0;
  margin: 0 auto 16px;
  cursor: pointer;

  &__checkbox {
    display: flex;
  }

  &__label {
    font-weight: 600;
    font-size: min(#{convertPXtoVW(14)}, 14px);
    line-height: 1.43;
    letter-spacing: 0.02em;
    color: $black;
  }
}
</style>
